<script>
import form from './form'

export default {
  extends: form,

  created() {
    window.isLoading(true)

    this.$apiMethods.stores.get(this.$route.params.id)
      .then(store => {
        this.form = store
        const { lon, lat } = store
        if (lon && lat) this.coordinates = lon + ', ' + lat
      })
      .finally(() => { window.isLoading(false) })
  },

  methods: {
    onSubmit() {
      return this.$apiMethods.stores.update(this.form.id, { ...this.form, ...this.getCoords, is_external: false })
        .then(() => {
          this.successSubmit({ message: 'Склад успешно изменен', routeName: 'rcc-stores' })
        })
        .finally(() => { this.afterSubmit() })
    }
  }
}
</script>
